import {
  Component,
  OnInit,
  input,
  signal,
} from '@angular/core';
import { ToastMessage, ToastType } from '../../models/toast.model';

const TOAST_ICON_PATH: Record<ToastType, string> = {
  info: '/images/icons/toast/info.svg',
  warning: '/images/icons/toast/warning.svg',
  error: '/images/icons/toast/error.svg',
  success: '/images/icons/toast/success.svg',
};

@Component({
  selector: 'app-toast-item',
  templateUrl: './toast-item.component.html',
  styleUrls: ['./toast-item.component.scss'],
  standalone: true,
  host: {
    class: 'toast-item-host',
    role: 'status',
    '[attr.aria-live]': 'toast().type === "error" ? "assertive" : null',
    '[class.toast-item-host--visible]': 'isVisible()',
    '[class.toast-item-host--leave]': 'toast().dismissing',
  },
})
export class ToastItemComponent implements OnInit {
  readonly toast = input.required<ToastMessage>();

  readonly isVisible = signal(false);

  iconPath(): string {
    return TOAST_ICON_PATH[this.toast().type];
  }

  ngOnInit(): void {
    requestAnimationFrame(() => {
      this.isVisible.set(true);
    });
  }
}
